import { useCallback, useMemo } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useLocale } from '#src/app/shared/hooks/l10n';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useCurrentUserId } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

export function useGetDashboardShareTrackingData(
	customData: Array<Record<string, string>> = [],
): ShareActionsOptions<ShareChannel>['getTrackingData'] {
	const userId = useCurrentUserId();
	const sourceLocation = useQueryParamValue('source_location');
	const locale = useLocale();
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	const { context, view_context: viewContext } = customData[0] || {};

	const commonTrackingData = useMemo(
		() => ({
			context: context || 'petition_dashboard_share_modal',
			view_context: viewContext || 'petition_dashboard_share_modal',
			source_location: sourceLocation,
			petition_id: `petition_${petition.id}`,
			own_petition: userId === petition.user.id,
		}),
		[sourceLocation, petition.id, petition.user.id, userId, context, viewContext],
	);

	return useCallback(
		(_channel: ShareChannel) => {
			const customTrackingData =
				customData.find((data) => {
					const { location } = data;
					return typeof location === 'string' && location.includes(_channel);
				}) || {};
			switch (_channel) {
				case 'facebook':
				case 'facebookMessenger':
					return {
						...commonTrackingData,
						...customTrackingData,
						api: true,

						petition_status: petition.status.toLowerCase(),
						fht: `fht-${petition.id}-${locale.toLowerCase()}`,
					};
				default:
					return {
						...commonTrackingData,
						...customTrackingData,
					};
			}
		},
		[commonTrackingData, petition.status, petition.id, locale, customData],
	);
}
